import React, { useState, useEffect, useRef } from 'react';
import { Outlet, Link } from "react-router-dom";
import "../CSS/home.css";
import "../CSS/global.css";
import { LOGO_SRC, ARROW_DOWN } from "../Constants.js";

function NavBar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);
  const navRef = useRef();

  // Close dropdowns when clicking outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (navRef.current && !navRef.current.contains(event.target)) {
        setOpenDropdown(null);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Prevent background scroll when menu is open (mobile)
  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "";
    return () => { document.body.style.overflow = ""; }
  }, [menuOpen]);

  // Helper to toggle dropdowns
  const handleDropdown = (name) => {
    setOpenDropdown(prev => (prev === name ? null : name));
  };

  return (
    <nav className="navbar" ref={navRef}>
      <div className="logos">
      </div>
      <ul className={`navbar-items ${menuOpen ? "active" : ""}`}>
        <li><Link to="/" className="navbar-item" onClick={() => setMenuOpen(false)}><p>Home</p></Link></li>
        <li className="dropdown-parent">
          <div
            className="navbar-item"
            onClick={() => handleDropdown('about')}
            tabIndex={0}
            aria-haspopup="true"
            aria-expanded={openDropdown === 'about'}
          >
            <p style = {{paddingRight : "10px"}}>About</p> <span><img src={ARROW_DOWN} width="10" alt="dropdown arrow" /></span>
          </div>
          {openDropdown === 'about' &&
            <div className="dropdownmenu">
              <Link to="/members" className="workshop-item" onClick={() => setMenuOpen(false)}>Conference Committee</Link>
              <Link to="/registrationfees" className="workshop-item" onClick={() => setMenuOpen(false)}>Registration Fees</Link>
            </div>
          }
        </li>
        <li><Link to="/callforpaper" className="navbar-item" onClick={() => setMenuOpen(false)}><p>Call For Paper</p></Link></li>
        <li><Link to="/keynotespeakers" className="navbar-item" onClick={() => setMenuOpen(false)}><p>Keynote Speakers</p></Link></li>
        <li className="dropdown-parent">
          <div
            className="navbar-item"
            onClick={() => handleDropdown('workshops')}
            tabIndex={0}
            aria-haspopup="true"
            aria-expanded={openDropdown === 'workshops'}
          >
            <p style = {{paddingRight : "10px"}}>Workshops</p> <span><img src={ARROW_DOWN} width="10" alt="dropdown arrow" /></span>
          </div>
          {openDropdown === 'workshops' &&
            <div className="dropdownmenu">
              <Link to="/workshopdigitalprivacy" className="workshop-item" onClick={() => setMenuOpen(false)}>Digital Privacy for Future Generation Healthcare</Link>
              <Link to="/workshopfederated" className="workshop-item" onClick={() => setMenuOpen(false)}>Robust Federated Learning on Edge Devices</Link>
            </div>
          }
        </li>
        <li className="dropdown-parent">
          <div
            className="navbar-item"
            onClick={() => handleDropdown('previous')}
            tabIndex={0}
            aria-haspopup="true"
            aria-expanded={openDropdown === 'previous'}
          >
            <p style = {{paddingRight : "10px"}}>Previous Editions</p> <span><img src={ARROW_DOWN} width="10" alt="dropdown arrow" /></span>
          </div>
          {openDropdown === 'previous' &&
            <div className="dropdownmenu">
              <Link to="/previousedition2023" className="workshop-item" onClick={() => setMenuOpen(false)}>CINS 2023</Link>
              <Link to="/previousedition2024" className="workshop-item" onClick={() => setMenuOpen(false)}>CINS 2024</Link>
            </div>
          }
        </li>
        <li><Link to="/contact" className="navbar-item" onClick={() => setMenuOpen(false)}><p>Contact</p></Link></li>
      </ul>
      <button
    // Add the className prop here
      className={`menu-toggle ${menuOpen ? "active" : ""}`} 
      aria-label="Toggle navigation menu"
      onClick={() => {
          setMenuOpen(!menuOpen);
          setOpenDropdown(null);
      }}>
    <span className="bar"></span>
    <span className="bar"></span>
    <span className="bar"></span>
    </button>
    </nav>
  );
}

export default NavBar;
